import DropdownFilter from "@/components/dropdown_filter";
import CollapsibleAgentTile from '@/components/collapsible_agent_tile'
import dynamic from 'next/dynamic'
import {useState, useEffect} from 'react'
const InteractiveMap = dynamic(() => import('@/components/interactive_map'), {ssr: false})
export default function AgencyMapView({ agencyNameSearch, stateProvinceOptions, searchState, searchAgencies, 
                                                   isLoading, searchInput, agents, totalCount, states, provinces}) {


  const [currentMap, setCurrentMap] = useState('US'); 
  const [resetMap, setResetMap] = useState(0);
  useEffect(() => {
     let selectedState = searchState.search['q[state_eq]'] 
    if (provinces.find((d, i) => d[0] ===  selectedState )) {
      setCurrentMap('CAN')
    }
    else if  (states.find((d, i) => d[0] ===  selectedState ) )  {
      setCurrentMap('US')
    }
   
  }, [searchState.search])
 
 

  return (
    <div className='lexcms-agency-map lexcms-agent-locator-page-container'>
      <div className='lexcms-agency-map-top'> 
        <h1 className='lexcms-title-display'>Locate a Sales Agency</h1>
        <div className='lexcms-map-top-controls'> 
          <div className='lexcms-rep-map-toggles'> 
            <a className={`${currentMap === 'US' ? 'active' : ''}`} onClick={( ) => setCurrentMap('US')  }>United States </a>
            <a className={`${currentMap === 'CAN' ? 'active' : ''}`} onClick={( ) => setCurrentMap('CAN')}>Canada</a>
          </div>
          <a  className='lexcms-rep-map-reset' onClick={( ) => setResetMap((state) => state + 1) }> Reset Map </a>
        </div>
      </div>
      <div className='lexcms-agency-map-main-container'>
        <div className='lexcms-agency-map-left'> 
          <div className='lexcms-map-filter-container'>
            <section className="lexcms-agent-locator-search-bar-container">
                  <input
                    ref={searchInput}
                    type="search"
                    onKeyUp={(event) => {    agencyNameSearch(event.target.value, searchState)  } }
                    defaultValue={searchState.search['q[name_cont]'] || ''}
                    placeholder="Search for Agencies"
                    className="lexcms-agent-locator-search"
                  />
            </section>
            <div className='lexcms-state-filter-row'>
            <DropdownFilter searchKey={'q[state_eq]'} 
              className='lexcms-agent-locator-state-province-filter'
              searchState={searchState}
              options={stateProvinceOptions} 
              label={'Filter by State or Province'} />
            <button className="lexcms-map-search-clear"
              onClick={ ( ) => {searchAgencies({}); 
                searchState.clearAll(); 
                if ( searchInput.current) {
                  searchInput.current.value = "";
                } }} >
              Clear Results
            </button>
            </div>
          </div>
          <h5 className='lexcms-rep-map-count-display'>Showing {totalCount} Results</h5>
          <div className='lexcms-agent-listings'> 
            {agents.map((agent, i) =>  (<CollapsibleAgentTile key={agent.id} agent={agent}/>) )}
          </div>
        </div>
        <div className='lexcms-agency-map-right'> 
          <InteractiveMap reset={resetMap} searchState={searchState} currentMap={currentMap} />
          <div className='lexcms-map-legend'>
            <p>Double-Click, Scroll or Pinch to Zoom</p>
          </div> 
        </div>
      </div>
    </div>
  )

}
